import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function formatCents(cents: number): string {
  return new Intl.NumberFormat('en-CA', { style: 'currency', currency: 'CAD' }).format(cents / 100);
}

export function formatDate(dateStr: string): string {
  // SQLite returns "YYYY-MM-DD" (date-only) or "YYYY-MM-DD HH:MM:SS".
  // A bare date is parsed by JS as UTC midnight, which renders the PREVIOUS day
  // in negative-offset timezones. Give it a local time component so it parses as
  // local (consistent with the datetime branch).
  const hasTime = dateStr.includes('T') || dateStr.includes(' ');
  const iso = hasTime ? dateStr.replace(' ', 'T') : `${dateStr}T00:00:00`;
  return new Date(iso).toLocaleDateString('en-CA');
}

/**
 * Local "today" as YYYY-MM-DD (en-CA formats as ISO). Use for date-input defaults
 * instead of `new Date().toISOString().slice(0, 10)`, which returns the UTC day and
 * can be tomorrow late in the evening for negative-offset timezones.
 */
export function todayISO(): string {
  return new Date().toLocaleDateString('en-CA');
}
